import { api } from "../../../../api";
import type {
  CancelShippingCasesByPricesIdResponse,
  EditShippingCasesByPricesIdRequest,
  EditShippingCasesByPricesIdResponse,
  ModifyPricePayload,
  RequestShippingCasesPricesByIdParams,
  RequestShippingCasesPricesCustomersParams,
  SaveManageServicesRequest,
  ShippingCasesPricesByIdItem,
  ShippingCasesPricesByIdResponse,
  ShippingCasesPricesCustomersResponse,
} from "./types";

export async function getShippingCasesPricesByIdApi(
  id: number,
  params: RequestShippingCasesPricesByIdParams,
): Promise<ShippingCasesPricesByIdResponse> {
  const { data } = await api.get<ShippingCasesPricesByIdResponse>(
    `/api/shipping-cases/${id}/prices`,
    { params },
  );
  return data;
}

export async function getShippingCasesPricesCustomersApi(
  id: number,
  params?: RequestShippingCasesPricesCustomersParams,
): Promise<ShippingCasesPricesCustomersResponse[]> {
  const { data } = await api.get<ShippingCasesPricesCustomersResponse[]>(
    `/api/shipping-cases/${id}/prices/customers`,
    { params },
  );
  return data;
}

export async function cancelShippingCasesByPricesIdApi(
  sid: number,
  pricesId: number,
): Promise<CancelShippingCasesByPricesIdResponse> {
  const { data } = await api.post<CancelShippingCasesByPricesIdResponse>(
    `/api/shipping-cases/${sid}/prices/${pricesId}/cancel`,
  );
  return data;
}

export async function modifySelectedServicePriceApi(
  sid: number,
  pricesId: number,
  params: ModifyPricePayload,
): Promise<ShippingCasesPricesByIdItem> {
  const { data } = await api.patch<ShippingCasesPricesByIdItem>(
    `/api/shipping-cases/${sid}/prices/${pricesId}`,
    params,
  );
  return data;
}

export async function restoreServiceApi(
  sid: number,
  serviceId: number,
): Promise<CancelShippingCasesByPricesIdResponse> {
  const { data } = await api.post<CancelShippingCasesByPricesIdResponse>(
    `/api/shipping-cases/${sid}/prices/${serviceId}/restore`,
  );
  return data;
}

export async function editShippingCasesByPricesIdApi(
  sid: number,
  pricesId: number,
  payload: Partial<EditShippingCasesByPricesIdRequest>,
): Promise<EditShippingCasesByPricesIdResponse> {
  const { data } = await api.patch<EditShippingCasesByPricesIdResponse>(
    `/api/shipping-cases/${sid}/prices/${pricesId}`,
    payload,
  );
  return data;
}

export async function saveManageServicesApi(
  id: number,
  payload: SaveManageServicesRequest,
): Promise<void> {
  await api.put<void>(`/api/shipping-cases/${id}/prices`, payload);
}

export async function sendDataInvoiceApi(sid: number): Promise<void> {
  await api.post<void>(`/api/shipping-cases/${sid}/prices/trigger-invoice`);
}
